module.exports = __webpack_public_path__ + "assets/img/bell.310cd960.svg";